if (!customElements.get('background-banner-video')) {
  customElements.define('background-banner-video', class extends HTMLElement {
    connectedCallback() {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateMotion = () => {
        if (this.motionQuery.matches) {
          this.querySelector('iframe')?.remove();
          this.classList.remove('is-loaded');
          return;
        }
        if (!this.querySelector('iframe')) {
          const iframe = this.querySelector('template').content.firstElementChild.cloneNode(true);
          iframe.addEventListener('load', () => this.classList.add('is-loaded'), { once: true });
          this.append(iframe);
        }
        this.resizeVideo();
      };
      this.resizeVideo = () => {
        const ratio = Number(this.dataset.ratio) || 16 / 9;
        const width = Math.max(this.clientWidth, this.clientHeight * ratio);
        this.style.setProperty('--video-width', `${Math.ceil(width)}px`);
        this.style.setProperty('--video-height', `${Math.ceil(width / ratio)}px`);
      };
      this.resizeObserver = new ResizeObserver(this.resizeVideo);
      this.resizeObserver.observe(this);
      this.motionQuery.addEventListener('change', this.updateMotion);
      this.updateMotion();
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.motionQuery.removeEventListener('change', this.updateMotion);
      this.querySelector('iframe')?.remove();
      this.classList.remove('is-loaded');
    }
  });
}